import { Component, type ErrorInfo, type ReactNode } from 'react';
import type { IErrors } from './types';

interface IErrorBoundaryProps {
  errors: IErrors;
  children: ReactNode;
  fallback?: ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  state: IErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): IErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    this.props.errors.capture(error, {
      tags: { source: 'ErrorBoundary' },
      extra: { componentStack: info.componentStack },
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div
            className="loading-container"
            role="alert"
          >
            <p className="loading-text">Algo deu errado. Recarregue a página.</p>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
